export type PrizmIdentityMatcher<I> = (item1: I, item2: I) => boolean;
